<template>
  <div class="sales-order-page">
    <div class="inquire-module-list" id="page-top">
      <a-row :gutter="24">
        <a-col :md="4" :sm="6">
          <a-range-picker v-model="dateValue" format="YYYY-MM-DD" @change="changeData" />
        </a-col>
        <a-col :md="3" :sm="6">
          <a-select style="width: 100%;" placeholder="选择发货门店" v-model="formData.storesName" @change="selectStores">
            <a-icon slot="suffixIcon" type="caret-down" style="color: #555555" />
            <a-select-option v-for="(item, index) in storesList" :key="index">
              <span>{{ item.storeName }}</span>
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :md="3" :sm="6">
          <a-input placeholder="输入单据编号搜索" v-model="formData.code" />
        </a-col>
        <a-col :md="4" :sm="6" class="button-ant-col">
          <a-button class="ant-btn-color border-arc" @click="btnInquire">查询</a-button>
          <a-button class="border-arc" @click="btnResetData">重置</a-button>
        </a-col>
      </a-row>
    </div>
    <div class="sales-order-list-table">
      <a-tabs default-active-key="-1" @change="callback">
        <a-tab-pane key="-1">
          <div slot="tab" class="tab-title">
            <span class="icon-image icon-image-quanbu"></span>
            <span>全部</span>
          </div>
          <div class="sales-order-table page-table" :style="{height: contentHeight+'px'}">
            <a-table :columns="columns" :dataSource="dataSource" :pagination="false" rowKey="id"
              :scroll="{ y: tableHeight }" bordered>
              <template slot="serialNum" slot-scope="text, record, index">
                <span>{{  index+1 }}</span>
              </template>
              <!-- 商品名称 -->
              <template slot="goodsNameStr" slot-scope="text, record">
                <a-tooltip>
                  <template slot="title">
                    <span>{{ text }}</span>
                  </template>
                  <div class="text-overflow">
                    <img src="@/assets/image/zengpin.png" style="width: 22px;margin-right: 5px"
                      v-if="record.giftFlag==1">
                    <img src="@/assets/image/manage_zong@2x.png" style="width: 22px" v-if="record.assemblyFlag==1">
                    <span class="name-text"> {{ text }}</span>
                  </div>
                </a-tooltip>
              </template>
              <!-- 商品编号 -->
              <template slot="code" slot-scope="text">
                <a-tooltip>
                  <template slot="title">
                    <span>{{ text }}</span>
                  </template>
                  <div class="text-overflow">
                    <span class="name-text"> {{ text }}</span>
                  </div>
                </a-tooltip>
              </template>
              <!-- 商品备注 -->
              <template slot="memberRemark" slot-scope="text">
                <a-tooltip>
                  <template slot="title">
                    <span>{{ text }}</span>
                  </template>
                  <div class="text-overflow">
                    <span class="name-text"> {{ text }}</span>
                  </div>
                </a-tooltip>
              </template>
              <!-- 状态 -->
              <template slot="state" slot-scope="text">
                <div class="order-staus">
                  <span class="status-round"
                    :style="{backgroundColor:text==0?'#FF0000' :text==1?'#F76F14' :text==6?'#AAAAAA' :'#199A2C'}"></span>
                  <span
                    :style="{color: text==0?'#FF0000' :text==1?'#F76F14' :text==2?'#199A2C' :text==3?'#333333' :text==4?'#555555' :'#AAAAAA'}">
                    {{  text==0?"待支付" :text==1?"待发货" :text==2?"待收货" :text==3?"已收货" :text==4?"已完成" :text==7?"已关闭" :"--" }}
                  </span>
                </div>
              </template>
              <template slot="operation" slot-scope="text, record">
                <span style="color: #387BFC;cursor: pointer;" v-if="record.status==1"
                  @click="btnGoSalesOrderDetails(record)">编辑</span>
                <span style="color: #387BFC;cursor: pointer;" v-else @click="btnGoSalesOrderDetails(record)">查看</span>
              </template>
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="0" force-render>
          <div slot="tab" class="tab-title">
            <span class="icon-image icon-image-daizhifu"></span>
            <span>待支付</span>
          </div>
          <div class="sales-order-table page-table" :style="{height: contentHeight+'px'}">
            <a-table :columns="columns" :dataSource="dataSource" :pagination="false" rowKey="id"
              :scroll="{ y: tableHeight }" bordered>
              <template slot="serialNum" slot-scope="text, record, index">
                <span>{{  index+1 }}</span>
              </template>
              <!-- 商品名称 -->
              <template slot="goodsNameStr" slot-scope="text, record">
                <a-tooltip>
                  <template slot="title">
                    <span>{{ text }}</span>
                  </template>
                  <div class="text-overflow">
                    <img src="@/assets/image/zengpin.png" style="width: 22px;margin-right: 5px"
                      v-if="record.giftFlag==1">
                    <img src="@/assets/image/manage_zong@2x.png" style="width: 22px" v-if="record.assemblyFlag==1">
                    <span class="name-text"> {{ text }}</span>
                  </div>
                </a-tooltip>
              </template>
              <!-- 商品编号 -->
              <template slot="code" slot-scope="text">
                <a-tooltip>
                  <template slot="title">
                    <span>{{ text }}</span>
                  </template>
                  <div class="text-overflow">
                    <span class="name-text"> {{ text }}</span>
                  </div>
                </a-tooltip>
              </template>
              <!-- 商品备注 -->
              <template slot="memberRemark" slot-scope="text">
                <a-tooltip>
                  <template slot="title">
                    <span>{{ text }}</span>
                  </template>
                  <div class="text-overflow">
                    <span class="name-text"> {{ text }}</span>
                  </div>
                </a-tooltip>
              </template>
              <!-- 状态 -->
              <template slot="state" slot-scope="text">
                <div class="order-staus">
                  <span class="status-round"
                    :style="{backgroundColor:text==0?'#FF0000' :text==1?'#F76F14' :text==6?'#AAAAAA' :'#199A2C'}"></span>
                  <span
                    :style="{color: text==0?'#FF0000' :text==1?'#F76F14' :text==2?'#199A2C' :text==3?'#333333' :text==4?'#555555' :'#AAAAAA'}">
                    {{  text==0?"待支付" :text==1?"待发货" :text==2?"待收货" :text==3?"已收货" :text==4?"已完成" :text==7?"已关闭" :"--" }}
                  </span>
                </div>
              </template>
              <template slot="operation" slot-scope="text, record">
                <span style="color: #387BFC;cursor: pointer;" v-if="record.status==1"
                  @click="btnGoSalesOrderDetails(record)">编辑</span>
                <span style="color: #387BFC;cursor: pointer;" v-else @click="btnGoSalesOrderDetails(record)">查看</span>
              </template>
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="1">
          <div slot="tab" class="tab-title">
            <span class="icon-image icon-image-daifahuo"></span>
            <span>待发货</span>
          </div>
          <div class="sales-order-table page-table" :style="{height: contentHeight+'px'}">
            <a-table :columns="columns" :dataSource="dataSource" :pagination="false" rowKey="id"
              :scroll="{ y: tableHeight }" bordered>
              <template slot="serialNum" slot-scope="text, record, index">
                <span>{{  index+1 }}</span>
              </template>
              <!-- 商品名称 -->
              <template slot="goodsNameStr" slot-scope="text, record">
                <a-tooltip>
                  <template slot="title">
                    <span>{{ text }}</span>
                  </template>
                  <div class="text-overflow">
                    <img src="@/assets/image/zengpin.png" style="width: 22px;margin-right: 5px"
                      v-if="record.giftFlag==1">
                    <img src="@/assets/image/manage_zong@2x.png" style="width: 22px" v-if="record.assemblyFlag==1">
                    <span class="name-text"> {{ text }}</span>
                  </div>
                </a-tooltip>
              </template>
              <!-- 商品编号 -->
              <template slot="code" slot-scope="text">
                <a-tooltip>
                  <template slot="title">
                    <span>{{ text }}</span>
                  </template>
                  <div class="text-overflow">
                    <span class="name-text"> {{ text }}</span>
                  </div>
                </a-tooltip>
              </template>
              <!-- 商品备注 -->
              <template slot="memberRemark" slot-scope="text">
                <a-tooltip>
                  <template slot="title">
                    <span>{{ text }}</span>
                  </template>
                  <div class="text-overflow">
                    <span class="name-text"> {{ text }}</span>
                  </div>
                </a-tooltip>
              </template>
              <!-- 状态 -->
              <template slot="state" slot-scope="text">
                <div class="order-staus">
                  <span class="status-round"
                    :style="{backgroundColor:text==0?'#FF0000' :text==1?'#F76F14' :text==6?'#AAAAAA' :'#199A2C'}"></span>
                  <span
                    :style="{color: text==0?'#FF0000' :text==1?'#F76F14' :text==2?'#199A2C' :text==3?'#333333' :text==4?'#555555' :'#AAAAAA'}">
                    {{  text==0?"待支付" :text==1?"待发货" :text==2?"待收货" :text==3?"已收货" :text==4?"已完成" :text==7?"已关闭" :"--" }}
                  </span>
                </div>
              </template>
              <template slot="operation" slot-scope="text, record">
                <span style="color: #387BFC;cursor: pointer;" v-if="record.status==1"
                  @click="btnGoSalesOrderDetails(record)">编辑</span>
                <span style="color: #387BFC;cursor: pointer;" v-else @click="btnGoSalesOrderDetails(record)">查看</span>
              </template>
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="2">
          <div slot="tab" class="tab-title">
            <span class="icon-image icon-image-daishouhuo"></span>
            <span>待收货</span>
          </div>
          <div class="sales-order-table page-table" :style="{height: contentHeight+'px'}">
            <a-table :columns="columns" :dataSource="dataSource" :pagination="false" rowKey="id"
              :scroll="{ y: tableHeight }" bordered>
              <template slot="serialNum" slot-scope="text, record, index">
                <span>{{  index+1 }}</span>
              </template>
              <!-- 商品名称 -->
              <template slot="goodsNameStr" slot-scope="text, record">
                <a-tooltip>
                  <template slot="title">
                    <span>{{ text }}</span>
                  </template>
                  <div class="text-overflow">
                    <img src="@/assets/image/zengpin.png" style="width: 22px;margin-right: 5px"
                      v-if="record.giftFlag==1">
                    <img src="@/assets/image/manage_zong@2x.png" style="width: 22px" v-if="record.assemblyFlag==1">
                    <span class="name-text"> {{ text }}</span>
                  </div>
                </a-tooltip>
              </template>
              <!-- 商品编号 -->
              <template slot="code" slot-scope="text">
                <a-tooltip>
                  <template slot="title">
                    <span>{{ text }}</span>
                  </template>
                  <div class="text-overflow">
                    <span class="name-text"> {{ text }}</span>
                  </div>
                </a-tooltip>
              </template>
              <!-- 商品备注 -->
              <template slot="memberRemark" slot-scope="text">
                <a-tooltip>
                  <template slot="title">
                    <span>{{ text }}</span>
                  </template>
                  <div class="text-overflow">
                    <span class="name-text"> {{ text }}</span>
                  </div>
                </a-tooltip>
              </template>
              <!-- 状态 -->
              <template slot="state" slot-scope="text">
                <div class="order-staus">
                  <span class="status-round"
                    :style="{backgroundColor:text==0?'#FF0000' :text==1?'#F76F14' :text==6?'#AAAAAA' :'#199A2C'}"></span>
                  <span
                    :style="{color: text==0?'#FF0000' :text==1?'#F76F14' :text==2?'#199A2C' :text==3?'#333333' :text==4?'#555555' :'#AAAAAA'}">
                    {{  text==0?"待支付" :text==1?"待发货" :text==2?"待收货" :text==3?"已收货" :text==4?"已完成" :text==7?"已关闭" :"--" }}
                  </span>
                </div>
              </template>
              <template slot="operation" slot-scope="text, record">
                <span style="color: #387BFC;cursor: pointer;" v-if="record.status==1"
                  @click="btnGoSalesOrderDetails(record)">编辑</span>
                <span style="color: #387BFC;cursor: pointer;" v-else @click="btnGoSalesOrderDetails(record)">查看</span>
              </template>
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="3">
          <div slot="tab" class="tab-title">
            <span class="icon-image icon-image-yishouhuo"></span>
            <span>已收货</span>
          </div>
          <div class="sales-order-table page-table" :style="{height: contentHeight+'px'}">
            <a-table :columns="columns" :dataSource="dataSource" :pagination="false" rowKey="id"
              :scroll="{ y: tableHeight }" bordered>
              <template slot="serialNum" slot-scope="text, record, index">
                <span>{{  index+1 }}</span>
              </template>
              <!-- 商品名称 -->
              <template slot="goodsNameStr" slot-scope="text, record">
                <a-tooltip>
                  <template slot="title">
                    <span>{{ text }}</span>
                  </template>
                  <div class="text-overflow">
                    <img src="@/assets/image/zengpin.png" style="width: 22px;margin-right: 5px"
                      v-if="record.giftFlag==1">
                    <img src="@/assets/image/manage_zong@2x.png" style="width: 22px" v-if="record.assemblyFlag==1">
                    <span class="name-text"> {{ text }}</span>
                  </div>
                </a-tooltip>
              </template>
              <!-- 商品编号 -->
              <template slot="code" slot-scope="text">
                <a-tooltip>
                  <template slot="title">
                    <span>{{ text }}</span>
                  </template>
                  <div class="text-overflow">
                    <span class="name-text"> {{ text }}</span>
                  </div>
                </a-tooltip>
              </template>
              <!-- 商品备注 -->
              <template slot="memberRemark" slot-scope="text">
                <a-tooltip>
                  <template slot="title">
                    <span>{{ text }}</span>
                  </template>
                  <div class="text-overflow">
                    <span class="name-text"> {{ text }}</span>
                  </div>
                </a-tooltip>
              </template>
              <!-- 状态 -->
              <template slot="state" slot-scope="text">
                <div class="order-staus">
                  <span class="status-round"
                    :style="{backgroundColor:text==0?'#FF0000' :text==1?'#F76F14' :text==6?'#AAAAAA' :'#199A2C'}"></span>
                  <span
                    :style="{color: text==0?'#FF0000' :text==1?'#F76F14' :text==2?'#199A2C' :text==3?'#333333' :text==4?'#555555' :'#AAAAAA'}">
                    {{  text==0?"待支付" :text==1?"待发货" :text==2?"待收货" :text==3?"已收货" :text==4?"已完成" :text==7?"已关闭" :"--" }}
                  </span>
                </div>
              </template>
              <template slot="operation" slot-scope="text, record">
                <span style="color: #387BFC;cursor: pointer;" v-if="record.status==1"
                  @click="btnGoSalesOrderDetails(record)">编辑</span>
                <span style="color: #387BFC;cursor: pointer;" v-else @click="btnGoSalesOrderDetails(record)">查看</span>
              </template>
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="4">
          <div slot="tab" class="tab-title">
            <span class="icon-image icon-image-yiwancheng"></span>
            <span>已完成</span>
          </div>
          <div class="sales-order-table page-table" :style="{height: contentHeight+'px'}">
            <a-table :columns="columns" :dataSource="dataSource" :pagination="false" rowKey="id"
              :scroll="{ y: tableHeight }" bordered>
              <template slot="serialNum" slot-scope="text, record, index">
                <span>{{  index+1 }}</span>
              </template>
              <!-- 商品名称 -->
              <template slot="goodsNameStr" slot-scope="text, record">
                <a-tooltip>
                  <template slot="title">
                    <span>{{ text }}</span>
                  </template>
                  <div class="text-overflow">
                    <img src="@/assets/image/zengpin.png" style="width: 22px;margin-right: 5px"
                      v-if="record.giftFlag==1">
                    <img src="@/assets/image/manage_zong@2x.png" style="width: 22px" v-if="record.assemblyFlag==1">
                    <span class="name-text"> {{ text }}</span>
                  </div>
                </a-tooltip>
              </template>
              <!-- 商品编号 -->
              <template slot="code" slot-scope="text">
                <a-tooltip>
                  <template slot="title">
                    <span>{{ text }}</span>
                  </template>
                  <div class="text-overflow">
                    <span class="name-text"> {{ text }}</span>
                  </div>
                </a-tooltip>
              </template>
              <!-- 商品备注 -->
              <template slot="memberRemark" slot-scope="text">
                <a-tooltip>
                  <template slot="title">
                    <span>{{ text }}</span>
                  </template>
                  <div class="text-overflow">
                    <span class="name-text"> {{ text }}</span>
                  </div>
                </a-tooltip>
              </template>
              <!-- 状态 -->
              <template slot="state" slot-scope="text">
                <div class="order-staus">
                  <span class="status-round"
                    :style="{backgroundColor:text==0?'#FF0000' :text==1?'#F76F14' :text==6?'#AAAAAA' :'#199A2C'}"></span>
                  <span
                    :style="{color: text==0?'#FF0000' :text==1?'#F76F14' :text==2?'#199A2C' :text==3?'#333333' :text==4?'#555555' :'#AAAAAA'}">
                    {{  text==0?"待支付" :text==1?"待发货" :text==2?"待收货" :text==3?"已收货" :text==4?"已完成" :text==7?"已关闭" :"--" }}
                  </span>
                </div>
              </template>
              <template slot="operation" slot-scope="text, record">
                <span style="color: #387BFC;cursor: pointer;" v-if="record.status==1"
                  @click="btnGoSalesOrderDetails(record)">编辑</span>
                <span style="color: #387BFC;cursor: pointer;" v-else @click="btnGoSalesOrderDetails(record)">查看</span>
              </template>
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="7">
          <div slot="tab" class="tab-title">
            <span class="icon-image icon-image-yiguanbi"></span>
            <span>已关闭</span>
          </div>
          <div class="sales-order-table page-table" :style="{height: contentHeight+'px'}">
            <a-table :columns="columns" :dataSource="dataSource" :pagination="false" rowKey="id"
              :scroll="{ y: tableHeight }" bordered>
              <template slot="serialNum" slot-scope="text, record, index">
                <span>{{  index+1 }}</span>
              </template>
              <!-- 商品名称 -->
              <template slot="goodsNameStr" slot-scope="text, record">
                <a-tooltip>
                  <template slot="title">
                    <span>{{ text }}</span>
                  </template>
                  <div class="text-overflow">
                    <img src="@/assets/image/zengpin.png" style="width: 22px;margin-right: 5px"
                      v-if="record.giftFlag==1">
                    <img src="@/assets/image/manage_zong@2x.png" style="width: 22px" v-if="record.assemblyFlag==1">
                    <span class="name-text"> {{ text }}</span>
                  </div>
                </a-tooltip>
              </template>
              <!-- 商品编号 -->
              <template slot="code" slot-scope="text">
                <a-tooltip>
                  <template slot="title">
                    <span>{{ text }}</span>
                  </template>
                  <div class="text-overflow">
                    <span class="name-text"> {{ text }}</span>
                  </div>
                </a-tooltip>
              </template>
              <!-- 商品备注 -->
              <template slot="memberRemark" slot-scope="text">
                <a-tooltip>
                  <template slot="title">
                    <span>{{ text }}</span>
                  </template>
                  <div class="text-overflow">
                    <span class="name-text"> {{ text }}</span>
                  </div>
                </a-tooltip>
              </template>
              <!-- 状态 -->
              <template slot="state" slot-scope="text">
                <div class="order-staus">
                  <span class="status-round"
                    :style="{backgroundColor:text==0?'#FF0000' :text==1?'#F76F14' :text==6?'#AAAAAA' :'#199A2C'}"></span>
                  <span
                    :style="{color: text==0?'#FF0000' :text==1?'#F76F14' :text==2?'#199A2C' :text==3?'#333333' :text==4?'#555555' :'#AAAAAA'}">
                    {{  text==0?"待支付" :text==1?"待发货" :text==2?"待收货" :text==3?"已收货" :text==4?"已完成" :text==7?"已关闭" :"--" }}
                  </span>
                </div>
              </template>
              <template slot="operation" slot-scope="text, record">
                <span style="color: #387BFC;cursor: pointer;" v-if="record.status==1"
                  @click="btnGoSalesOrderDetails(record)">编辑</span>
                <span style="color: #387BFC;cursor: pointer;" v-else @click="btnGoSalesOrderDetails(record)">查看</span>
              </template>
            </a-table>
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>
    <div class="pagination-box">
      <a-pagination :total="ipagination.total" :page-size="ipagination.pageSize" :default-current="ipagination.current"
        :show-total="ipagination.showTotal" @showSizeChange="onShowSizeChange" @change="onChangeIpagination"
        show-size-changer show-quick-jumper />
    </div>
  </div>
</template>
<script>
import { publicMethod } from "../method/publicMethod";
import { salesOrde } from "../method/salesOrde";
import { tableWidth } from "@/mixins/tableWidth";
export default {
  name: "salesOrder",
  mixins: [publicMethod, salesOrde, tableWidth],
  data() {
    return {
      columns: [
        {
          title: "序号",
          align: "center",
          width: 80,
          dataIndex: "serialNum",
          scopedSlots: { customRender: "serialNum" },
        },
        {
          defaultWidth: 200,
          title: "订单商品",
          dataIndex: "goodsNameStr",
          scopedSlots: { customRender: "goodsNameStr" },
        },
        {
          defaultWidth: 200,
          title: "单据编号",
          dataIndex: "code",
          scopedSlots: { customRender: "code" },
        },
        {
          title: "单据日期",
          ellipsis: true,
          dataIndex: "orderDate",
        },
        // {
        //   title: "经办人",
        //   ellipsis: true,
        //   dataIndex: "transactorName",
        // },
        {
          title: "金额",
          align: "right",
          dataIndex: "afterTaxAmount",
          scopedSlots: { customRender: "afterTaxAmount" },
        },
        {
          title: "收货人",
          dataIndex: "receiveName",
        },
        {
          title: "发货门店",
          dataIndex: "outStoreName",
        },
        {
          title: "数量",
          dataIndex: "goodsTotalCount",
        },
        {
          defaultWidth: 180,
          title: "备注",
          dataIndex: "remark",
          scopedSlots: { customRender: "remark" },
        },
        {
          title: "状态",
          dataIndex: "state",
          scopedSlots: { customRender: "state" },
        },
        {
          title: "操作",
          align: "center",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
        },
      ],
      urlList: {},
    };
  },
  activated() {
    this.init();
    this.getStaffListSelect();
  },
  methods: {
    // 查看详情
    btnGoSalesOrderDetails(record) {
      this.$router.push({
        path:
          "/cloudstore/sales/selladmin/salesOrderDetails?id=" +
          record.id +
          "&&type=" +
          record.state,
      });
    },
  },
};
</script>
<style lang="scss">
@import "../style/salesOrder.scss";
.sales-order-page {
  width: 100%;
  // 列表头部样式
  .inquire-module-list {
    height: 76px;
    padding: 0 25px;
    background-color: #ffffff;
    .ant-row {
      height: 80px !important;
      display: flex;
      align-items: center;
    }
    .button-ant-col {
      display: flex;
      .ant-btn {
        width: 80px !important;
      }
      .ant-btn-color {
        margin-right: 16px;
      }
    }
  }

  .ant-tabs-bar {
    .ant-tabs-tab-active {
      color: #387bfc;
      .icon-image-quanbu {
        background-image: url("../../../../assets/image/make_offers_quanbu1.png");
      }
      .icon-image-daizhifu {
        background-image: url("../../../../assets/image/daizhifu.png");
      }
      .icon-image-daifahuo {
        background-image: url("../../../../assets/image/daifahuo.png");
      }
      .icon-image-daishouhuo {
        background-image: url("../../../../assets/image/daishouhuo.png");
      }
      .icon-image-yishouhuo {
        background-image: url("../../../../assets/image/yishouhuo.png");
      }
      .icon-image-yiwancheng {
        background-image: url("../../../../assets/image/yiwancheng.png");
      }
      .icon-image-yiguanbi {
        background-image: url("../../../../assets/image/yiguanbi.png");
      }
    }
    .ant-tabs-nav .ant-tabs-tab:hover {
      color: #387bfc;
      .icon-image-quanbu {
        background-image: url("../../../../assets/image/make_offers_quanbu1.png");
      }
      .icon-image-daizhifu {
        background-image: url("../../../../assets/image/daizhifu.png");
      }
      .icon-image-daifahuo {
        background-image: url("../../../../assets/image/daifahuo.png");
      }
      .icon-image-daishouhuo {
        background-image: url("../../../../assets/image/daishouhuo.png");
      }
      .icon-image-yishouhuo {
        background-image: url("../../../../assets/image/yishouhuo.png");
      }
      .icon-image-yiwancheng {
        background-image: url("../../../../assets/image/yiwancheng.png");
      }
      .icon-image-yiguanbi {
        background-image: url("../../../../assets/image/yiguanbi.png");
      }
    }
  }

  .text-overflow {
    width: 100%;
    height: 36px;
    line-height: 36px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    .name-text {
      padding-left: 5px;
    }
  }
  .sales-order-list-table {
    margin-top: 16px;
    background-color: #ffffff;
    .ant-table-fixed-left {
      .ant-table-body-inner {
        margin-right: -8px !important;
        margin-bottom: 0 !important;
      }
      .ant-table-body-outer {
        margin-bottom: 0 !important;
      }
    }
    .ant-table-fixed-right {
      .ant-table-body-outer {
        margin-bottom: 0 !important;
      }
    }
  }
}
</style>
